module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "plans-section",
    attrs: {
      "id": "plans"
    }
  }, [_c('div', {
    staticClass: "plans-inner"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Choose a plan")]), _vm._v(" "), _c('h2', {
    staticClass: "text-xs-center mt-3"
  }, [_vm._v("Start your 30 day free trial")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "justify-space-between": "",
      "mt-4": ""
    }
  }, _vm._l((_vm.plansData), function(plan, n) {
    return _c('plan', {
      key: n,
      attrs: {
        "plan": plan,
        "id": plan.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n    * Upload features only for verified artist accounts\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2643954","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing3/Plans.vue
// module id = 1838
// module chunks = 180